<template>
      <div no-body class="lku-cashflow"> 
      <b-row>
        <b-col lg="8">
          <b-form-group label-cols=3 label="Filter Account">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.kodecash" @keyup.13.native="refresh()" placeholder="Code"></b-form-input></b-col>
                <b-col class="pl-1" cols="7"><b-form-input v-model="tblData.namacash" @keyup.13.native="refresh()" placeholder="Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCf" style="font-size:smaller;" 
          responsive striped hover small
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(accname)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.accname"></span>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-cashflow {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import coa from "../../apis/cashflowacc";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "kodecash",
            label: "Account Code",
            thStyle: "width:130px",
          },
          {
            key: "accname",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:150px",
            label: "Type"
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'kodecash',
        sortDesc: false,
      },
      updatetable:false,
    };
  },
  props: ['allowHeader',`formdata`,`typeacc`],
  created: async function() {
    this.tblData.typeacc = this.typeacc;
      this.$emit('update:allowHeader', false);
      if (this.formdata.items)
      {
          for (var key in this.formdata) {
              this.tblData[key] = this.formdata[key];
          }
      } else {
        this.data();
      }
  },
  computed: {
    filterKode() {
      return this.tblData.kodecash;
    },
    filterNamaAcc() {
      return this.tblData.namacash;
    },
  },
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
    filterKode: function(kode) {
      setTimeout(() => {
        if (kode == this.tblData.kodecash) this.refresh();
      }, 500);
    },    
    filterNamaAcc: function(namacash) {
      setTimeout(() => {
        if (namacash == this.tblData.namacash) this.refresh();
      }, 500);
    },    
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const items= await coa.list(this.tblData);      
      this.tblData.items = items;      
      this.updatetable=!this.updatetable;

    },
    selectItem(item,index) {
      if (this.allowHeader == true){
          this.tblData.selected=item;
          this.$emit("click", this.tblData);
      } else {
        if (item.judul!=='Y'){
          this.tblData.selected=item;
          this.$emit("click", this.tblData);
        } else {
          toastr.warn('Account punya anak tidak boleh dipilih!');
        }
      }
    },
    refresh() {
       this.data();
      this.$refs.tblCf.refresh();
    }
  }
};
</script>
